import { MODALS } from 'common/domain/constants';
class ToggleSwitchController {
  constructor($scope, EventEmitter) {
    'ngInject';
    this.$scope = $scope;
    this.EventEmitter = EventEmitter;

    this.$scope.$watch(() => this.enabled, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        return this.onChange(this.EventEmitter({ enabled: newValue }));
      }
    });
  }

  isDisabled() {
    return !!this.disabled;
  }

  get modal() {
    const $modal = $(MODALS.MANDATORY_INSURANCE);
    return $modal;
  }

  openModal() {
    this.modal.modal('show');
  }

  mandatoryInsuranceAlert() {
    if (this.isDisabled()) {
      this.alertMessage = '{{ "LOANS.SIGN_UP.FORM_SIMULATION.MANDATORY_INSURANCE_WARNING" | translate }}';
      this.showAlert = true;
      this.openModal();
      return;
    }
  }
}

export default ToggleSwitchController;



// WEBPACK FOOTER //
// ./client/app/components/toggleSwitch/toggleSwitch.controller.js